import React from 'react';

import { t } from 'i18next';
import { Trans } from 'react-i18next';

import { TRANSLATION_POINTS_BY_FILE } from '../../../../../shared/translations/rewards';
import './RewardsPointsTextArea.scss';

interface RewardsPointsTextAreaProps {
  value: string;
  onChange: (value: string) => void;
}

const RewardsPointsTextArea = ({ value, onChange }: RewardsPointsTextAreaProps) => {
  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newValue = event.target.value.slice(0, 200);
    const filteredValue = newValue.replace(/\n/g, '').replace(/[^a-zA-Z0-9\s.,;:´'"¿?¡!\-áéíóúüÁÉÍÓÚÜñÑ]/g, '');
    onChange(filteredValue);
  };

  return (
    <div className="rewards-points-text-area">
      <p className="text-area-label">
        {<Trans i18nKey={TRANSLATION_POINTS_BY_FILE.emailsConfiguration.messageLabel} components={{ b: <b></b> }} />}
      </p>
      <textarea
        value={value}
        onChange={handleChange}
        maxLength={200}
        placeholder={t(TRANSLATION_POINTS_BY_FILE.emailsConfiguration.textAreaPlaceholder)}
      />
      <div className="helper-text">{value.length}/200</div>
    </div>
  );
};

export default RewardsPointsTextArea;
